import PopupMenu, { MenuContainer } from "./PopupMenu";
import Item from "./Item";
import Section from "./Section";
import Dialog from "./Dialog";
import ContextMenuAnchor from "./ContextMenuAnchor";
import MenuItemRenderer from "./MenuItemRenderer";
import { AnyObject } from "../../models";

type PopupMenuComponent = typeof PopupMenu & {
  Item: typeof Item;
  Dialog: typeof Dialog;
  Section: typeof Section;
  ContextMenuAnchor: typeof ContextMenuAnchor;
  MenuContainer: typeof MenuContainer;
  MenuItemRenderer: typeof MenuItemRenderer;
};

const Component = PopupMenu as AnyObject;
Component.Item = Item;
Component.Dialog = Dialog;
Component.Section = Section;
Component.ContextMenuAnchor = ContextMenuAnchor;
Component.MenuContainer = MenuContainer;
Component.MenuItemRenderer = MenuItemRenderer;

export type { MenuProps } from "./PopupMenu";

export default Component as PopupMenuComponent;
